<template lang="pug">
k-menu.k-admin-menu
  w-menu-action( to='/admin/main' )
    i-dashboard( slot='icon' )
    | Dashboard
  w-menu-action( to='/admin/programs' )
    i-program( slot='icon' )
    | Programs
  w-menu-action( to='/admin/content' )
    i-content( slot='icon' )
    | Content
  k-menu
    w-menu-action( to='/admin/content/videos' )
      i-video( slot='icon' )
      | Videos
    w-menu-action( to='/admin/content/audios' )
      i-audio( slot='icon' )
      | Audio Files
    w-menu-action( to='/admin/content/new' )
      i-upload( slot='icon' )
      | Recent Uploads
    w-menu-action( to='/admin/content/collections' )
      i-collection( slot='icon' )
      | Collections
    w-menu-action( to='/admin/content/tags' )
      i-tag( slot='icon' )
      | Tags
  w-menu-action( to='/admin/settings' )
    i-settings( slot='icon' )
    | Settings
</template>

<script lang="js">
import KMenu from '@/blocks/k-menu'
import WMenuAction from '@/widgets/w-menu-action'
import IAudio from 'icons/Speaker'
import ICollection from 'icons/FormatListText'
import IContent from 'icons/Filmstrip'
import IDashboard from 'icons/ViewDashboard'
import IProgram from 'icons/Clipboard'
import ISettings from 'icons/Cog'
import ITag from 'icons/Tag'
import IUpload from 'icons/Upload'
import IVideo from 'icons/Video'

export default {
  name: 'AdminMenuBlock',
  mixins: [],
  components: {
    KMenu,
    WMenuAction,
    IAudio,
    ICollection,
    IContent,
    IDashboard,
    IProgram,
    ISettings,
    ITag,
    IUpload,
    IVideo,
  },
  props: {},
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.k-admin-menu {
  .k-menu {
    transition: 250ms margin, 250ms border;
  }
}
.main-menu {
  &.open, &:hover {
    .k-admin-menu {
      .k-menu {
        margin-top: var(--s-sm);
        margin-bottom: var(--s-sm);
        margin-left: var(--s-sm);
        border-left: 2px solid rgba(0,0,0,0.1);
      }
    }
  }
}
</style>
